import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
import { SectionSide } from "../../utils/side/types";
import { cnSection, toPx } from "../../utils/side";
var cn = classNames.bind(styles);
var _CardSection = function _CardSection(_ref) {
  var children = _ref.children,
    minHeight = _ref.minHeight,
    align = _ref.align,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? SectionSide.vAuto : _ref$side,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('section', cnSection({
      side: side
    }), align && "align--".concat(align), className),
    style: {
      minHeight: toPx(minHeight)
    },
    "data-t-id": "Card-CardSection"
  }, children);
};
export var CardSection = enhancedConnect({
  /**
   * В будущем может быть расширено на left, right, hMiddle (для горизонтальных карточек)
   */
  children: PropTypes.node,
  align: PropTypes.oneOf([undefined, 'center', 'left', 'right']),
  minHeight: PropTypes.number,
  side: PropTypes.oneOf(Object.values(SectionSide))
})(_CardSection);